import { SvgIcon, SvgIconProps } from "@mui/material";
import * as React from "react";

interface IconProps extends SvgIconProps {}

const LinkIcon = ({ hovered = false, ...props }): IconProps => {
  return (
    <SvgIcon {...props}
      sx={{
        ...props.sx,
        "& rect":   { fill: "currentColor", fillOpacity: 0 },
        "&:hover rect":   { fillOpacity: 0.1 },
        "& path":   { stroke: "currentColor", strokeWidth: props.strokeWidth ?? 1.2 },
      }}
    >
      {hovered ? (
        <>
          <rect
            y="14.8406"
            width="20.6432"
            height="9.25126"
            rx="4"
            transform="rotate(-45.9643 0 14.8406)"
            fill="#1976D2"
            fill-opacity="0.1"
          />
          <path
            d="M9.02539 5.21331L10.9977 3.24089C12.8573 1.38129 15.8722 1.38129 17.7319 3.24089C19.5915 5.10051 19.5915 8.11552 17.7319 9.97514L15.7596 11.9475"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.7194 15.9884L9.7471 17.9608C7.88749 19.8204 4.87248 19.8204 3.01287 17.9608C1.15326 16.1012 1.15326 13.0862 3.01287 11.2266L4.98513 9.25415"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.0661 7.90759L7.67871 13.295"
            stroke="#1976D2"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </>
      ) : (
        <>
          <rect
            y="14.8406"
            width="20.6432"
            height="9.25126"
            rx="4"
            transform="rotate(-45.9643 0 14.8406)"
            fill="none"
          />
          <path
            d="M9.02539 5.21331L10.9977 3.24089C12.8573 1.38129 15.8722 1.38129 17.7319 3.24089C19.5915 5.10051 19.5915 8.11552 17.7319 9.97514L15.7596 11.9475"
            stroke="currentColor"
            stroke-width={props?.strokeWidth ?? "1.2"}
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.7194 15.9884L9.7471 17.9608C7.88749 19.8204 4.87248 19.8204 3.01287 17.9608C1.15326 16.1012 1.15326 13.0862 3.01287 11.2266L4.98513 9.25415"
            stroke="currentColor"
            stroke-width={props?.strokeWidth ?? "1.2"}
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.0661 7.90759L7.67871 13.295"
            stroke="currentColor"
            stroke-width={props?.strokeWidth ?? "1.2"}
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default LinkIcon;